import axiosClient from "./axiosClient"

const articleApi = {
  getAll: params =>
    axiosClient.get("/articles/", { params, authRequired: true }),
  getById: id => axiosClient.get(`/articles/${id}/`, { authRequired: true }),
  getTopViewed: () =>
    axiosClient.get("/articles/top_viewed/", { authRequired: true }),
  likeArticle: id =>
    axiosClient.post(`/articles/${id}/like/`, {}, { authRequired: true }),
  unlikeArticle: id =>
    axiosClient.post(`/articles/${id}/unlike/`, {}, { authRequired: true }),
  getLikedByUser: articleIds => {
    if (!articleIds || articleIds.length === 0) {
      return Promise.resolve({})
    }
    const params = { article_ids: articleIds.join(',') }
    return axiosClient.get("/articles/liked-by-user/", { params, authRequired: true })
  },
}

export default articleApi
